import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">读者反馈</h2>
          <p className="mt-2 text-sm text-foreground-500">赛事爱好者们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentItems.map((comment, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl p-5 border border-background-200/70 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-300">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.date}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{comment.text}</p>
              <div className="mt-3 flex items-center gap-1 text-secondary-500">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}